module.exports = __webpack_public_path__ + "img/dld-right-a.970c5dc1.png";